// This icon file is generated automatically.
var FilterOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M8.4 14.6l1.32 1.15c.3.25.32.69.08.98a.69.69 0 01-.98.08l-1.57-1.36a.7.7 0 01-.24-.52v-7L1.17 1.17A.7.7 0 011.7 0h16.62c.59 0 .9.7.52 1.16l-5.85 6.78V19.3a.7.7 0 01-.7.7.7.7 0 01-.68-.7V7.68a.7.7 0 01.16-.46L16.8 1.4H3.2l5.02 5.82c.1.13.17.29.17.46v6.92z" } }] }, "name": "filter", "theme": "outlined" };
export default FilterOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/FilterOutlined.js
// module id = 2770
// module chunks = 0